import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { membershipLockGuard } from './guards/membership-lock.guard';
import { adminAuthGuard } from './guards/admin-auth.guard';
import { memberGuestGuard } from './guards/member-guest.guard';
import { AdminAuditLogPage } from './pages/admin/auditlog/admin-audit-log.page';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canMatch: [memberGuestGuard],
    loadComponent: () =>
      import('../app/pages/common/landing/landing.page').then(m => m.LandingPage),
  },

  {
    path: 'member/login',
    canMatch: [memberGuestGuard],
    loadComponent: () =>
      import('../app/pages/member/auth/login/member-login.page').then(m => m.MemberLoginPage)
  },
  {
    path: 'member/guide-book',
    loadComponent: () =>
      import('../app/pages/common/member-guidebook/member-guidebook.component').then(m => m.MemberGuidebookComponent)
  },

  {
    path: 'admin/guide-book',
    loadComponent: () =>
      import('../app/pages/common/admin-guidebook/admin-guidebook.component').then(m => m.AdminGuidebookComponent)
  },

  {
    path: 'member/dashboard',
    loadComponent: () => import('./pages/member/dashboard/member-dashboard.page').then(m => m.MemberDashboardPage),
    canActivate: [authGuard, membershipLockGuard],
  },

  {
    path: 'member/register',
    canMatch: [memberGuestGuard],
    loadComponent: () =>
      import('./pages/member/register/register-member.page').then(m => m.RegisterMemberPage)
  },

  {
    path: 'member/select-membership',
    loadComponent: () => import('./pages/member/select-membership/member-select-membership.page').then(m => m.MemberSelectMembershipPage),
    canActivate: [authGuard],
  },

  {
    path: 'profile-docs-completion',
    loadComponent: () => import('./pages/member/profile-docs-completion/profile-docs-completion.component')
      .then(m => m.ProfileDocsCompletionComponent)
  },

  {
    path: 'member/membership-status',
    loadComponent: () =>
      import('./pages/member/membership-status/member-membership-status.page')
        .then(m => m.MemberMembershipStatusPage),
    canActivate: [authGuard]
  },

  {
    path: 'member/restoration',
    loadComponent: () =>
      import('./pages/member/restoration/member-restoration.page')
        .then(m => m.MemberRestorationPage),
    canActivate: [authGuard],
  },
  {
    path: 'member/renewal',
    loadComponent: () =>
      import('./pages/member/renewal/member-renewal.page')
        .then(m => m.MemberRenewalPage),
    canActivate: [authGuard],
  },

  // ---------------- ADMIN ----------------
  {
    path: 'admin/login',
    loadComponent: () =>
      import('./pages/admin/login/admin-login.page').then(m => m.AdminLoginPage),
  },


  {
    path: 'admin',
    loadComponent: () =>
      import('./pages/admin/layout/admin-layout.page')
        .then(m => m.AdminLayoutPage),
    canActivate: [adminAuthGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/admin/dashboard/admin-dashboard.page')
            .then(m => m.AdminDashboardPage),
      },
      {
        path: 'renewal',
        loadComponent: () =>
          import('./pages/admin/renewal/admin-renewal.page')
            .then(m => m.AdminRenewalPage),
      },
      {
        path: 'restoration',
        loadComponent: () =>
          import('./pages/admin/restoration/admin-restoration.page')
            .then(m => m.AdminRestorationPage),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./pages/admin/settings/admin-settings.page')
            .then(m => m.AdminSettingsPage),
      },

      {
        path: 'audit',
        loadComponent: () =>
          import('./pages/admin/auditlog/admin-audit-log.page')
            .then(m => m.AdminAuditLogPage)
      },


      // placeholders (we will create later)
      {
        path: 'documents',
        loadComponent: () =>
          import('./pages/admin/documents/admin-documents-list.page')
            .then(m => m.AdminDocumentsListPage),
      },
      {
        path: 'documents/:memberId',
        loadComponent: () =>
          import('./pages/admin/documents/admin-documents-detail.page')
            .then(m => m.AdminDocumentsDetailPage),
      },
      { path: 'audit', redirectTo: 'dashboard', pathMatch: 'full' },


      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },

  // ✅ wildcard MUST be last
  { path: '**', redirectTo: '' },
];
